import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const GoodRankIndictor = () => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(messages.tooltipMessage)}>
			<Box
				xcss={rankIndicatorStyles}
				testId="autodev-agent-picker.ui.picker-content.good-rank-indicator"
			/>
		</Tooltip>
	);
};

const rankIndicatorStyles = xcss({
	width: '12px',
	height: '12px',
	borderRadius: '6px',
	backgroundColor: 'color.background.success.bold',
});
